var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ethers } from 'ethers';
import { getAddress } from 'ethers/lib/utils';
import { getSupportedTokens } from '../../Fct/plugins/allowanceRequiredProtocols';
import { provider } from '../../Fct/plugins/provider/provider';
var tokenLists = {
    '1': getSupportedTokens({ chainId: '1' }),
    '42161': getSupportedTokens({ chainId: '42161' }),
    '10': getSupportedTokens({ chainId: '10' }),
    '8453': getSupportedTokens({ chainId: '8453' }),
    '11155111': getSupportedTokens({ chainId: '11155111' }),
};
var Utils = /** @class */ (function () {
    function Utils() {
    }
    var _a;
    _a = Utils;
    Utils.getSupportedTokens = function (_b) {
        var chainId = _b.chainId;
        return tokenLists[chainId];
    };
    Utils.getERC20Data = function (_b) {
        var chainId = _b.chainId, address = _b.address;
        var tokens = tokenLists[chainId];
        if (!tokens)
            throw new Error("ChainId ".concat(chainId, " not supported"));
        var token = tokens.find(function (token) { return getAddress(token.value) === getAddress(address); });
        if (!token)
            throw new Error("Data for token ".concat(address, " not found"));
        return token;
    };
    Utils.getErc20BalanceOf = function (_b) {
        var chainId = _b.chainId, address = _b.address, account = _b.account;
        return __awaiter(void 0, void 0, void 0, function () {
            var erc20Contract, balance;
            return __generator(_a, function (_c) {
                switch (_c.label) {
                    case 0:
                        erc20Contract = new ethers.Contract(address, ['function balanceOf(address _owner) view returns (uint256 balance)'], provider[chainId]);
                        return [4 /*yield*/, erc20Contract.balanceOf(account)];
                    case 1:
                        balance = (_c.sent()).toString();
                        return [2 /*return*/, balance];
                }
            });
        });
    };
    Utils.getErc721BalanceOf = _a.getErc20BalanceOf;
    Utils.getErc1155BalanceOf = function (_b) {
        var chainId = _b.chainId, address = _b.address, id = _b.id, account = _b.account;
        return __awaiter(void 0, void 0, void 0, function () {
            var erc1155Contract, balance;
            return __generator(_a, function (_c) {
                switch (_c.label) {
                    case 0:
                        erc1155Contract = new ethers.Contract(address, ['function balanceOf(address _owner, uint256 id) view returns (uint256 balance)'], provider[chainId]);
                        return [4 /*yield*/, erc1155Contract.balanceOf(account, id)];
                    case 1:
                        balance = (_c.sent()).toString();
                        return [2 /*return*/, balance];
                }
            });
        });
    };
    return Utils;
}());
export { Utils };
